export const mapPaginationResponse = (response, mapper) => {
  return {
    page: response.data.page,
    count: response.data.count,
    totalPages: response.data.total_pages,
    results: response.data.results.map(mapper),
  };
}